import { Button, Grid2 as Grid, Typography, Paper, styled } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PropTypes from 'prop-types';

const CardTrnasferencias = ({ uploadFile, loading }) => {
  const CardInfo = styled(Paper)(() => ({
    backgroundColor: "#F1F1F1",
    borderRadius: 8,
    paddingTop: 35,
    paddingBottom: 35,
    paddingRight: 30,
    paddingLeft: 30,
  }));
  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  return (
    <CardInfo>
      <Typography className="titleMain" variant="h3" component="h2">Transferencias bancarias</Typography>
      <Typography className="subtitleMain" mt={1}>
        También podrás hacer uso de transferencias interbancarias con los siguientes datos como método de pago.
      </Typography>

      <Typography sx={{ color: '#0E2465' }} mt={3}>Banco Receptor:</Typography>
      <Typography className="titleMain" mb={2}>BANCO INBURSA</Typography>

      <Typography sx={{ color: '#0E2465' }}>CLABE Interbancaria:</Typography>
      <Typography className="titleMain" mb={2}>036180500714167429</Typography>

      <Typography sx={{ color: '#0E2465' }}>No. de cuenta:</Typography>
      <Typography className="titleMain" mb={2}>50071416742</Typography>

      <Typography sx={{ color: '#0E2465' }}>Nombre del Beneficiario:</Typography>
      <Typography className="titleMain" mb={2}>
        ONE SERVICES MEXGRO S.A. DE C.V.
        </Typography>

      <Typography sx={{ color: '#0E2465' }}>Concepto de Pago:</Typography>
      <Typography className="titleMain" mb={4}>
        Inversión Inicial - Proyecto One Service
      </Typography>

      <hr className="separator" />
      <Grid container spacing={3} sx={{my: 2}}>
        <Grid size={{ sm: 7 }} mt={2}>
          <Typography className="subtitleMain">
            <small>
              Una vez realizada la transferencia, podrás subir tu comprobante de pago en el siguiente botón para validar tu inversión.
            </small>
          </Typography>
        </Grid>
        <Grid size={{ xs:12, sm: 5 }} mt={2}>
          <Button
            component="label"
            variant="contained"
            tabIndex={-1}
            loading={loading}
            loadingPosition="end"
            endIcon={<CloudUploadIcon />}
            fullWidth
          >
            Adjuntar
            <VisuallyHiddenInput
              type="file"
              accept=".pdf, .png, .jpg, .jpeg"
              onChange={e => uploadFile(e.target.files)}
            />
          </Button>
        </Grid>
      </Grid>
    </CardInfo>
  )
}

CardTrnasferencias.propTypes = {
  uploadFile: PropTypes.func.isRequired
}

export default CardTrnasferencias